// ── Color math ────────────────────────────────────────────────────────────────

export const hsvToRgb = (h, s, v) => {
  const i = Math.floor(h / 60) % 6
  const f = h / 60 - Math.floor(h / 60)
  const p = v * (1 - s)
  const q = v * (1 - f * s)
  const t = v * (1 - (1 - f) * s)
  return [[v, t, p], [q, v, p], [p, v, t], [p, q, v], [t, p, v], [v, p, q]][i]
    .map(c => Math.round(c * 255))
}

export const rgbToHex = (r, g, b) =>
  '#' + [r, g, b].map(c => c.toString(16).padStart(2, '0')).join('')

export const hexToHsv = (hex) => {
  const safe = /^#[0-9a-f]{6}$/i.test(hex) ? hex : '#2a2a2a'
  const r = parseInt(safe.slice(1, 3), 16) / 255
  const g = parseInt(safe.slice(3, 5), 16) / 255
  const b = parseInt(safe.slice(5, 7), 16) / 255
  const max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min
  let h = 0
  if (d !== 0) {
    if (max === r) h = ((g - b) / d + 6) % 6
    else if (max === g) h = (b - r) / d + 2
    else h = (r - g) / d + 4
    h *= 60
  }
  return { h, s: max === 0 ? 0 : d / max, v: max }
}

export const hsvToHex = ({ h, s, v }) => rgbToHex(...hsvToRgb(h, s, v))

// ── Canvas rendering ──────────────────────────────────────────────────────────

export const WHEEL_SIZE = 156
export const RADIUS = WHEEL_SIZE / 2 - 3

export const drawWheel = (ctx, brightness) => {
  const cx = WHEEL_SIZE / 2
  const cy = WHEEL_SIZE / 2
  const imageData = ctx.createImageData(WHEEL_SIZE, WHEEL_SIZE)
  const { data } = imageData
  for (let y = 0; y < WHEEL_SIZE; y++) {
    for (let x = 0; x < WHEEL_SIZE; x++) {
      const dx = x - cx, dy = y - cy
      const dist = Math.sqrt(dx * dx + dy * dy)
      if (dist > RADIUS) continue
      const hue = ((Math.atan2(dy, dx) * 180 / Math.PI) + 360) % 360
      const sat = dist / RADIUS
      const [r, g, b] = hsvToRgb(hue, sat, brightness)
      const i = (y * WHEEL_SIZE + x) * 4
      data[i] = r; data[i + 1] = g; data[i + 2] = b; data[i + 3] = 255
    }
  }
  ctx.putImageData(imageData, 0, 0)
}

export const drawSelector = (ctx, h, s, borderColor) => {
  const cx = WHEEL_SIZE / 2, cy = WHEEL_SIZE / 2
  const angle = (h * Math.PI) / 180
  const dist = s * RADIUS
  const sx = cx + Math.cos(angle) * dist
  const sy = cy + Math.sin(angle) * dist
  ctx.beginPath()
  ctx.arc(sx, sy, 6, 0, Math.PI * 2)
  ctx.strokeStyle = '#ffffff'
  ctx.lineWidth = 2
  ctx.stroke()
  ctx.beginPath()
  ctx.arc(sx, sy, 6, 0, Math.PI * 2)
  ctx.strokeStyle = 'rgba(0,0,0,0.4)'
  ctx.lineWidth = 1
  ctx.stroke()
}
